export const WORKFLOWS_TABLE_TYPE = 'WORKFLOWS_TABLE';
export const WORKFLOWS_TABLE_KEY = 'WORKFLOWS_TABLE_KEY';
